import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown } = FiIcons;

const roleColors = {
  Administrator: 'bg-red-50 text-red-700 border-red-200',
  'IT/Security Admin': 'bg-blue-100 text-blue-700 border-blue-200',
  Manager: 'bg-amber-100 text-amber-700 border-amber-200',
  Employee: 'bg-emerald-100 text-emerald-700 border-emerald-200',
};

const RoleSwitcher = () => {
  const { currentUser } = useAuth();
  const [open, setOpen] = useState(false);

  if (!currentUser) return null;

  return (
    <div className="relative">
      <button onClick={() => setOpen(o => !o)}
        className="flex items-center gap-2.5 px-2 py-1.5 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors shadow-sm">
        <div className="w-7 h-7 rounded-full bg-slate-800 text-[#00E5FF] text-xs font-bold flex items-center justify-center flex-shrink-0">
          {currentUser.avatar}
        </div>
        <SafeIcon icon={FiChevronDown} className={`text-slate-400 text-xs transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <motion.div initial={{ opacity: 0, y: 6, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 4 }}
              className="absolute right-0 top-full mt-2 w-64 bg-white rounded-2xl border border-slate-200 shadow-xl z-50 overflow-hidden">
              <div className="px-4 py-3 border-b border-slate-100 bg-slate-50">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Account Profile</p>
              </div>
              <div className="p-4 flex flex-col items-center text-center">
                 <div className="w-16 h-16 rounded-full bg-slate-800 text-[#00E5FF] text-xl font-bold flex items-center justify-center mb-3 shadow-inner">
                    {currentUser.avatar}
                 </div>
                 <p className="text-sm font-bold text-slate-800">{currentUser.name}</p>
                 <p className="text-xs text-slate-500 mb-3">{currentUser.email}</p>
                 <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold border ${roleColors[currentUser.role] || 'bg-slate-100 text-slate-700 border-slate-200'}`}>
                    {currentUser.role}
                 </span>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default RoleSwitcher;